import React, { useState } from 'react'
import { cdnImg } from 'meinian-package/src/utils/image'
import util from 'meinian-package/src/utils/util'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { RepeatCollectModal } from '../../../publicComponent/useFunModal/repeatCollectModal'
import CustomizeHeader, { CustomizeHeaderLeftDefault } from '../../components/header/customizeHeader'
import styles from './repeatCollect.module.less'
import './common.less'

export default () => {
  const [visible, setVisible] = useState(false)
  const [cardData, setCardData] = useState({})
  const onClick = (item) => {
    util.track('mn-repeat-collect-modal', {
      module1: '全局查重',
    })
    setCardData({ ...item })
    setVisible(true)
  }

  return (<>
    <CustomizeHeader
      hiddenSearch
      renderLeft={() => <CustomizeHeaderLeftDefault
        paths={[{
          name: '工作台',
          path: '/home/workbench/index'
        }, {
          name: '款式查重',
          path: null
        }
        ]}
      />}
    />
    <div className={styles['analysis-repeat-collect']}>
      <div style={{ paddingTop: 24 }}>
        <MNWaterfallApi
          renderItem={RepeatCard}
          cardProps={{ showMoveImage: true, allStyleFlag: true, onClick }} // allStyleFlag 区别于灵感集的硬编码
          url="/zhikuan/mn/collect-statistic/v2/duplicate-images"
          method="spost"
          params={{}}
          emptyText="暂无相关款式"
          emptyType="image"
        />
      </div>
      {
      visible && <RepeatCollectModal
        visible={visible}
        onClose={() => setVisible(false)}
        data={cardData}
      />
    }
    </div>
  </>)
}

const RepeatCard = ({ columnWidth, mainUrl, onClick, ...props }) => {
  const item = {
    mainUrl,
    collectRecords: props.collectRecords,
    inspirationNum: props.inspirationNum,
    userNum: props.userNum,
    platformId: props.platformId,
  }
  return (<div style={{ width: columnWidth, height: columnWidth + 52 }} onClick={() => onClick?.(item)}>
    <div className="analysis-repeat-collect-card-image">
      <img src={cdnImg(mainUrl, 500)} style={{ width: '100%', height: '100%', objectFit: 'cover', background: 'linear-gradient(rgba(0,0,0,0.03), rgba(0,0,0,0.03))' }} />
      <div className="analysis-repeat-collect-time"><span>{item.userNum}人采集</span><span className="analysis-repeat-collect-time-line" /><span>存在于{item.inspirationNum}个灵感集</span></div>
    </div>
  </div>)
}
